import { useContext } from 'react'

import { CurrencyContext } from '../contexts/currency'

export const useCurrency = () => useContext(CurrencyContext)

export default useCurrency
